module.exports = __webpack_public_path__ + "static/media/Flag_of_the_Czech_Republic.9c5898c6.svg";